import { ButtonBase } from '@mui/material';

import { Typography, SizingMultiplier } from '@ocx/ui';
import { PumpIcon } from '@ocx/ui-icons';

type SelectedPumpProps = {
  pumpNumber: string | number;
  onClick(): void;
};

export const SelectedPumpComponent = (props: SelectedPumpProps) => {
  const { pumpNumber, onClick } = props;

  return (
    <ButtonBase
      sx={{
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        py: SizingMultiplier.md,
        px: SizingMultiplier.lg,
        minHeight: 64,
        borderRadius: 2,
      }}
      onClick={onClick}>
      <PumpIcon sx={{ mr: SizingMultiplier.sm }} />
      <Typography variant="h4" component="span">
        {pumpNumber}
      </Typography>
    </ButtonBase>
  );
};
